
import { useNavigate } from "react-router-dom";
import AuthForm from "@/components/auth/AuthForm";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import LoadingState from "@/components/profile/LoadingState";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const SignIn = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [localLoading, setLocalLoading] = useState(true);
  const [isAuthRedirect, setIsAuthRedirect] = useState(false);

  // Check for auth redirect parameters in URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    const provider = urlParams.get('provider');
    const authType = urlParams.get('type');
    
    // Detect if this is an auth redirect
    const isRedirect = !!(error || provider || authType || 
                         urlParams.get('type') === 'recovery' || 
                         urlParams.get('type') === 'signup' || 
                         urlParams.get('type') === 'magiclink');
    
    console.log('Checking for auth redirect parameters:', { isRedirect, provider, error });
    setIsAuthRedirect(isRedirect);
    
    if (error) {
      console.error('Auth error in URL:', error, errorDescription);
    }
    
    // Check for Google auth in progress
    const googleAuthInProgress = sessionStorage.getItem('googleAuthInProgress');
    if (googleAuthInProgress) {
      console.log('Google auth process detected on sign-in page');
      setLocalLoading(true);
      
      if (error) {
        // Clear the flag if there was an error
        sessionStorage.removeItem('googleAuthInProgress');
        setLocalLoading(false);
      } else if (!user) {
        // Still processing
        console.log("Completing sign-in process...");
      }
    }
    
    // Short delay to allow auth to complete
    const timer = setTimeout(() => {
      setLocalLoading(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, [user]);

  // Redirect if user is logged in
  useEffect(() => {
    // Don't redirect during auth redirects
    if (user && !isLoading && !isAuthRedirect) {
      console.log('User already logged in, redirecting to dashboard');
      navigate('/dashboard', { replace: true });
    } else if (!isLoading) {
      setLocalLoading(false);
    }
  }, [user, isLoading, navigate, isAuthRedirect]);

  // Add a timeout to prevent infinite loading
  useEffect(() => {
    const timer = setTimeout(() => {
      console.log('Sign-in page loading timeout triggered');
      setLocalLoading(false);
    }, 2000); 
    
    return () => clearTimeout(timer);
  }, []);

  // Show loading while we check auth state
  if (isLoading && localLoading) {
    return <LoadingState />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="w-full max-w-md animate-fade-in">
          <AuthForm type="sign-in" />
          
          <div className="mt-4 text-center text-sm text-muted-foreground">
            <Link to="/forgot-password" className="hover:text-primary hover:underline transition-colors">
              Forgot your password?
            </Link>
          </div>
          
          <div className="mt-6 text-center text-sm text-muted-foreground">
            <p>
              Don't have an account?{" "}
              <Link to="/sign-up" className="text-primary hover:underline">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default SignIn;
